import Author from "components/author";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import formatCurrency from "helpers/formatCurrency";
import moment from "moment";

const AccNo = ({ accNo }) => (
  <MDBox lineHeight={1} textAlign="left">
    <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
      {accNo}
    </MDTypography>
  </MDBox>
);

export default function getConsumptionSummaryTableData(accounts) {
  const columns = [
    { Header: "Acc No", accessor: "acc_no", align: "center", minWidth: "40px" },
    { Header: "Name / Address", accessor: "name", align: "left" },
    { Header: "Date / Time", accessor: "reading_date", align: "left", minWidth: "74px" },
    { Header: "Reader", accessor: "reader", align: "left" },
    { Header: "Meter Reading", accessor: "reading", align: "center", minWidth: "90px" },
    { Header: "Units", accessor: "units", align: "center" },
    { Header: "Amount", accessor: "amount", align: "center" },
  ];

  return {
    columns: columns,
    rows: accounts.map((account) => {
      const reading = account.readings[0];
      const readingDate = reading?.createdAt
        ? moment(reading.createdAt).format("YY/MM/DD - hh:mm A")
        : "--";
      const reader = reading?.meter_reader?.name || "--";
      const currentReading = reading?.current_reading || "--";
      const units = reading?.units || "--";
      return {
        name: (
          <Author
            name={account.holder_name}
            address={account.address}
            transfers={account.transfers}
            lateReadings={account.late_readings}
          />
        ),
        acc_no: <AccNo accNo={account.account_number} />,
        reading_date: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {readingDate}
          </MDTypography>
        ),
        reader: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {reader}
          </MDTypography>
        ),
        reading: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {currentReading}
          </MDTypography>
        ),
        units: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {units}
          </MDTypography>
        ),
        amount: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {formatCurrency(reading?.price || 0)}
          </MDTypography>
        ),
      };
    }),
  };
}
